import React, { Suspense } from "react";
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import GlobalStyles from "./styles";
import App from "./App";
import './styles.css';
import StoreProvider from "./store/index";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const { REACT_APP_STRIPE } = process.env;
const stripeKey = REACT_APP_STRIPE ? REACT_APP_STRIPE : '';
const stripePromise = loadStripe(stripeKey);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Suspense>
      {/* <React.StrictMode> */}
        <Router>
          <StoreProvider>
            <Elements stripe={stripePromise}>
              <App/>
            </Elements>
            <ToastContainer />
          </StoreProvider>
        </Router>
        <GlobalStyles />
      {/* </React.StrictMode> */}
    </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
